import { REALTIME_ORDER_HUB_STATUS } from '../hubs/realtime/models/order-realtime.model';

export const DESKTOP_NS = 'ordersPage.desktopNotifications';
export const NOTIFICATION_SOUND_URL = 'assets/sounds/order-notification.wav';

export const MENU_CATALOG_BATCH_SOURCES = new Set<string>([
  'inventory-item-batch-upload',
  'inventory-category-batch-upload',
]);

export const MENU_CATALOG_SOURCE_LABEL: Record<string, string> = {
  'inventory-item-batch-upload': 'Inventory item batch upload',
  'inventory-category-batch-upload': 'Inventory category batch upload',
};

export const ORDER_STATUS_NOTIFICATION_MAP: Record<
  number,
  { titleKey: string; statusKey: string }
> = {
  [REALTIME_ORDER_HUB_STATUS.Created]: {
    titleKey: `${DESKTOP_NS}.updatedTitleCreated`,
    statusKey: `${DESKTOP_NS}.statusCreated`,
  },
  [REALTIME_ORDER_HUB_STATUS.Preparing]: {
    titleKey: `${DESKTOP_NS}.updatedTitlePreparing`,
    statusKey: `${DESKTOP_NS}.statusPreparing`,
  },
  [REALTIME_ORDER_HUB_STATUS.Ready]: {
    titleKey: `${DESKTOP_NS}.updatedTitleReady`,
    statusKey: `${DESKTOP_NS}.statusReady`,
  },
  [REALTIME_ORDER_HUB_STATUS.OutForDelivery]: {
    titleKey: `${DESKTOP_NS}.updatedTitleOutForDelivery`,
    statusKey: `${DESKTOP_NS}.statusOutForDelivery`,
  },
  [REALTIME_ORDER_HUB_STATUS.Delivered]: {
    titleKey: `${DESKTOP_NS}.updatedTitleDelivered`,
    statusKey: `${DESKTOP_NS}.statusDelivered`,
  },
  [REALTIME_ORDER_HUB_STATUS.Rejected]: {
    titleKey: `${DESKTOP_NS}.updatedTitleRejected`,
    statusKey: `${DESKTOP_NS}.statusRejected`,
  },
  [REALTIME_ORDER_HUB_STATUS.RejectedByCustomer]: {
    titleKey: `${DESKTOP_NS}.updatedTitleRejectedByCustomer`,
    statusKey: `${DESKTOP_NS}.statusRejectedByCustomer`,
  },
};

export const DEFAULT_NOTIFICATION_KEYS = {
  titleKey: `${DESKTOP_NS}.updatedTitleGeneric`,
  statusKey: `${DESKTOP_NS}.statusUnknown`,
};

export function resolveOrderNotificationKeys(status: number | null | undefined): {
  titleKey: string;
  statusKey: string;
} {
  if (status === null || status === undefined) {
    return (
      ORDER_STATUS_NOTIFICATION_MAP[REALTIME_ORDER_HUB_STATUS.Created] ??
      DEFAULT_NOTIFICATION_KEYS
    );
  }
  return ORDER_STATUS_NOTIFICATION_MAP[status] ?? DEFAULT_NOTIFICATION_KEYS;
}

export function formatOrderLabel(
  payload: { orderNumber?: string | null; id?: string | null },
  fallback: string,
): string {
  const num = String(payload.orderNumber ?? '').trim();
  if (num) return num;
  const id = String(payload.id ?? '').trim();
  return id || fallback;
}

export function interpolateOrderBody(
  template: string,
  orderLabel: string,
  statusLabel: string,
): string {
  return template
    .replaceAll('{{orderNumber}}', orderLabel)
    .replaceAll('{{status}}', statusLabel);
}

export function extractBatchId(
  data: Record<string, unknown> | null | undefined,
): string | null {
  const raw = data?.['batchId'];
  const batchId = typeof raw === 'string' ? raw.trim() : '';
  return batchId || null;
}
